(function () {
  function closeOnOutsideClick(selector) {
    document.addEventListener('click', function (event) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (el.open && !el.contains(event.target)) {
          el.removeAttribute('open');
        }
      });
    });
  }

  // Header burger menu drawer
  closeOnOutsideClick('#Details-menu-drawer-container');

  // Footer "Help?" popup
  closeOnOutsideClick('.footer-help');
})();
